<template lang="html">
    <div class="illustrator-client col-eight col-offset-2" :data-client-id="this.client.id" :data-client-weight="this.client.weight">
        <div class="drag-trigger"><i class="fa fa-arrows" aria-hidden="true"></i></div>
        <div class="col-nine client-name">
            {{ client.name }}
        </div>
        <div class="col-three align-center">
            <button class="big-purple-button" @click="deleteClient">Delete</button>
        </div>
    </div>
</template>

<script>
export default {
  props: ['client'],
  methods: {
    deleteClient() {
      axios.post('/profile/ajax/delete/client', {
        id: this.client.id,
        _method: 'delete'
      }).then(() => {
        this.$emit('clientDeleted', {
          id: this.client.id
        });
      });
    }
  },
  mounted() {

  }
};
</script>

<style lang="scss">
    .illustrator-client {
        position: relative;
        .client-name {
            vertical-align: middle;
            line-height: 55px;
            padding-left: 40px;
        }
    }
</style>